import { useState } from "react";

const CookieBanner = () => {
  const [visible, setVisible] = useState(true);
  const [showCustomize, setShowCustomize] = useState(false);

  if (!visible) return null;

  return (
    <>
      {!showCustomize && (
        <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-sm bg-white rounded-lg shadow-lg border border-gray-200 px-7 py-5 flex flex-col items-center">
          <h3 className="font-semibold text-lg text-gray-900 mb-2 text-center">
            We value your privacy
          </h3>
          <p className="text-gray-700 text-sm mb-4 text-center">
            We use cookies to enhance your browsing experience, serve
            personalized ads or content, and analyze our traffic. By clicking
            "Accept All", you consent to our use of cookies.
          </p>
          <div className="flex w-full gap-2 justify-center">
            <button
              className="flex-1 bg-white border-2 border-blue-600 text-blue-700 font-semibold py-2 rounded hover:bg-blue-50 transition"
              onClick={() => setShowCustomize(true)}
            >
              Customize
            </button>
            <button
              className="flex-1 bg-white border-2 border-blue-600 text-blue-700 font-semibold py-2 rounded hover:bg-blue-50 transition"
              onClick={() => setVisible(false)}
            >
              Reject All
            </button>
            <button
              className="flex-1 bg-blue-700 text-white font-semibold py-2 rounded hover:bg-blue-900 transition"
              onClick={() => setVisible(false)}
            >
              Accept All
            </button>
          </div>
        </div>
      )}

      {showCustomize && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white max-w-2xl w-full rounded-lg shadow-2xl border p-8 text-gray-800 relative overflow-y-auto max-h-[90vh]">
            <button
              className="absolute top-4 right-5 text-xl text-gray-500 hover:text-blue-700"
              onClick={() => setVisible(false)}
              title="Close"
            >
              &times;
            </button>
            <h2 className="font-bold text-2xl mb-4">
              Customize Consent Preferences
            </h2>
            <p className="mb-4">
              We use cookies to help you navigate efficiently and perform
              certain functions. You will find detailed information about all
              cookies under each consent category below.
              <br />
              <br />
              The cookies that are categorized as <strong>
                "Necessary"
              </strong>{" "}
              are stored on your browser as they are essential for enabling the
              basic functionalities of the site.
            </p>
            <p className="mb-4">
              We also use third-party cookies that help us analyze how you use
              this website, store your preferences, and provide the content and
              advertisements that are relevant to you. These cookies will only
              be stored in your browser with your prior consent.
            </p>
            <p className="mb-4">
              You can choose to enable or disable some or all of these cookies
              but disabling some of them may affect your browsing experience.
            </p>
            {/* Show less link (can be interactive) */}
            <button
              className="text-blue-700 hover:underline mb-2 text-sm text-left"
              onClick={() => setShowCustomize(false)}
            >
              Show less
            </button>
            {/* Cookie Categories */}
            <div className="border-t pt-4 mt-2">
              <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                  <span className="font-semibold text-lg">Necessary</span>
                  <span className="text-green-600 font-medium text-base">
                    Always Active
                  </span>
                </div>
                <p className="text-gray-600 text-sm">
                  Necessary cookies are required to enable the basic features of
                  this site, such as providing secure log-in or adjusting your
                  consent preferences. These cookies do not store any personally
                  identifiable data.
                </p>
              </div>
              {/* Add more cookie categories here if needed */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
